import { pb } from '@/libs/pocketbase'
import { tryCatch } from '@/utils/try-catch'
import type { CustomerLookupPort, WorkflowCustomer } from '../domain/workflow'

type CustomerRecord = {
	id: string
	name: string | null
}

// Reads the shared customers collection through the native PocketBase API,
// matching how the customers feature lists them. Only the id and name are
// projected: associating a work item with a customer needs nothing more, which
// keeps this lookup decoupled from the customers feature's richer model.
const pbCustomerLookup: CustomerLookupPort = {
	listCustomers: async query => {
		const filter = query ? pb.filter('name ~ {:q} || email ~ {:q}', { q: query }) : ''
		const result = await tryCatch(
			pb.collection('customers').getFullList<CustomerRecord>({ filter, sort: 'name', requestKey: null }),
		)
		if (!result.isSuccess) throw new Error(result.error.message)
		return result.data
			.filter((record): record is { id: string; name: string } => Boolean(record.name))
			.map<WorkflowCustomer>(record => ({ id: record.id, name: record.name }))
	},
}

export { pbCustomerLookup }
